import axiosInstance from '../utils/http';
import store from '../store';


// 设置基础URL 
const baseURL1 = 'https://diagapi.wwftool.top/api';//DNS自动解析
const baseURL2 = 'https://diagapi.us.wwftool.top/api';//海外服务器
const baseURL3 = 'https://diagapi.cn.wwftool.top/api';//国内服务器
const baseURL4 = 'http://diagapi.xk.wwftool.top:6482/api';//国内服务器


const mazdaLocalBaseURL = '/api/mazda';// 本地调试通过 devServer 代理，避免浏览器直接跨域

export const buildMazdaRequestUrl = (serverName, endpoint) => {
    const safeEndpoint = String(endpoint || '').replace(/^\/+/, '');

    if (serverName === 'CN Server') {
        return `${baseURL3}/mazda/${safeEndpoint}`;
    }
    if (serverName === 'US Server') {
        return `${baseURL2}/mazda/${safeEndpoint}`;
    }
    if (serverName === 'Local Server') {
        return `${mazdaLocalBaseURL}/${safeEndpoint}`;
    }

    return `${mazdaLocalBaseURL}/${safeEndpoint}`;
};
// 选择 baseURL 的辅助函数  
const chooseBaseURL = (useBaseURL) => {
    return useBaseURL ? baseURL3 : baseURL2;
};

const chooseBaseURLEx = (useBaseURL) => {
    if(useBaseURL === "CN Server")
        return baseURL3;
    else if(useBaseURL === "US Server")
        return baseURL2;
    else if(useBaseURL === "XK Server")
        return baseURL4; 
    else if(useBaseURL === "X431 Server")
        return baseURL1; 
    return baseURL1;
};

const chooseFordSimulatorBaseURL = (serverKey) => {
    return serverKey === 'us' || serverKey === 'US Server' ? baseURL2 : baseURL3;
};

const buildRequestUrl = (baseURL, urlFunc) => {
    // 定义特殊前缀映射
    const specialPrefixes = ['apidoc/', 'apiv2/'];
    const hasSpecialPrefix = specialPrefixes.some(prefix => urlFunc.startsWith(prefix));
    
    return hasSpecialPrefix 
        ? `${baseURL}/v1/${urlFunc}`
        : `${baseURL}/v1/diag/${urlFunc}`;
};

const Triggerdownload = (response) => {
    // 创建 Blob 对象并生成 URL
    const blob = new Blob([response.data], { type: response.headers['content-type'] });
    const url = URL.createObjectURL(blob);

    // 从响应头中提取文件名
    const contentDisposition = response.headers['content-disposition'];
    const filename = contentDisposition.split('; ')[1].split('=')[1].replace(/"/g, '');  // 移除引号

    // 创建一个临时 <a> 标签
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);

    // 将链接添加到文档中并模拟点击
    document.body.appendChild(link);
    link.click();

    // 清理
    document.body.removeChild(link);
    URL.revokeObjectURL(url);  // 释放 URL
};

const documentDown = (url, filename) => {
    // 创建一个临时 <a> 标签
    const link = document.createElement('a');
    link.href = url;

    // 设置下载文件的默认名称（可选）

    link.setAttribute('download', filename);

    // 将链接添加到文档中
    document.body.appendChild(link);

    // 模拟用户点击，触发下载
    link.click();

    // 删除临时链接
    document.body.removeChild(link);
};

//根据本地保存的token验证是否在有效期内
export const getUserInfo = () => {
    return axiosInstance.get(`${baseURL1}/v1/user/userinfo`);
};

//查询放到outcode
export const getOutCodebySn = (limit, sn) => {
    return axiosInstance.get(`${baseURL1}/v1/diag/getOutCodeInfo?limit=${limit}&sn=${sn}`);
};
//下载外码文件
export const downloadOutCodebyId = async (id) => {
    const response = await axiosInstance.get(`${baseURL1}/v1/diag/downloadOutCodeInfo?id=${id}`);
    Triggerdownload(response);// 创建一个 URL 并触发下载   
};


export const downloadVinInfobyId = async (useBaseURL) => {
    const baseURL = chooseBaseURL(useBaseURL);
    const response = await axiosInstance.get(`${baseURL}/v1/diag/downloadVinInfo`);
    Triggerdownload(response);// 创建一个 URL 并触发下载  
};

export const downloadVinInfobyId2 = async (useBaseURL) => {
    const baseURL = chooseBaseURL(useBaseURL);
    return axiosInstance.get(`${baseURL}/v1/diag/downloadVinInfo2`);
};

export const DownLoadVM = async (useBaseURL, vin) => {
    const baseURL = chooseBaseURL(useBaseURL);
    const response = await axiosInstance.get(`${baseURL}/v1/diag/downloadvm?vin=${vin}`);
    Triggerdownload(response);// 创建一个 URL 并触发下载  
};

export const DownLoadFile = async (useBaseURL, filename) => {
    //const baseURL = chooseBaseURL(useBaseURL);
    const baseURL = chooseBaseURLEx(useBaseURL);
    const token = localStorage.getItem("authToken");  
    const url = `${baseURL}/v1/diag/DownLoadFile?filename=${filename}&token=${token}`;
    documentDown(url, filename);
};

export const DownLoadFCD = async (useBaseURL, vin) => {
    const baseURL = chooseBaseURL(useBaseURL);
    const response = await axiosInstance.get(`${baseURL}/v1/diag/downloadfcd?vin=${vin}`);
    Triggerdownload(response);// 创建一个 URL 并触发下载  
};

export const DownLoadJM = async (useBaseURL, vin) => {
    const baseURL = chooseBaseURL(useBaseURL);

    const response = await axiosInstance.get(`${baseURL}/v1/diag/downloadjm?vin=${vin}`, {
        responseType: 'blob'  // 设置响应类型为 blob，这样就能正确处理二进制数据
    });
    Triggerdownload(response);// 创建一个 URL 并触发下载  
};

export const DownLoadZip = (useBaseURL, zip) => {
    const baseURL = chooseBaseURL(useBaseURL);
    const url = `${baseURL}/v1/diag/downloadpacked?filename=${zip}`;
    const filename = zip + '.zip';
    documentDown(url, filename);
};


export const TryLoginTool = (useBaseURL, data) => {
    const baseURL = chooseBaseURL(useBaseURL);
    return axiosInstance.post(`${baseURL}/v1/diag/trylogintool`, data, { timeout: 120 * 1000 });//单独设置最长等待时间
};

export const getVinStatus = (useBaseURL, vin) => {
    const baseURL = chooseBaseURL(useBaseURL);
    return axiosInstance.get(`${baseURL}/v1/diag/getVinStatus?vin=${vin}`);
};

export const getVinKey = (useBaseURL, vin) => {
    const baseURL = chooseBaseURL(useBaseURL);
    return axiosInstance.get(`${baseURL}/v1/diag/getvinkey?vin=${vin}`);
};

export const getHid = (useBaseURL) => {
    const baseURL = chooseBaseURL(useBaseURL);
    return axiosInstance.get(`${baseURL}/v1/diag/gethid`);
};

export const setHid = (useBaseURL, hidvalue) => {
    const baseURL = chooseBaseURL(useBaseURL);
    return axiosInstance.get(`${baseURL}/v1/diag/sethid?hid=${hidvalue}`);
};



export const getVinUploadInfo = (useBaseURL, vin) => {
    const baseURL = chooseBaseURL(useBaseURL);
    return axiosInstance.get(`${baseURL}/v1/diag/getvinuploadinfo?vin=${vin}`);
};

export const MovePackedInfo = (useBaseURL, zip) => {
    const baseURL = chooseBaseURL(useBaseURL);
    return axiosInstance.get(`${baseURL}/v1/diag/movepackedinfo?filename=${zip}`);
};


export const deleteVinUploadInfo = (useBaseURL, vin) => {
    const baseURL = chooseBaseURL(useBaseURL);
    return axiosInstance.get(`${baseURL}/v1/diag/deletevinuploadinfo?vin=${vin}`);
};

export const getPackedInfo = (useBaseURL) => {
    const baseURL = chooseBaseURL(useBaseURL);
    return axiosInstance.get(`${baseURL}/v1/diag/getpackedinfo`);
};

export const CmdUsingXmlTool = (useBaseURL) => {
    const baseURL = chooseBaseURL(useBaseURL);
    return axiosInstance.get(`${baseURL}/v1/diag/cmdusingxmltool?limit=800&loopcnt=10`);//每次编译800个VIN，生成10个压缩包数据
};

export const CmdUsingXmlToolEx = (useBaseURL) => {
    const baseURL = chooseBaseURL(useBaseURL);
    return axiosInstance.get(`${baseURL}/v1/diag/cmdusingxmltoolEx`);
};

export const requestVindata = (useBaseURL, vin) => {
    const baseURL = chooseBaseURL(useBaseURL);
    return axiosInstance.get(`${baseURL}/v1/diag/trydownloadvin?vin=${vin}`);
};

export const getVinInfo = (useBaseURL) => {
    const baseURL = chooseBaseURL(useBaseURL);
    return axiosInstance.get(`${baseURL}/v1/diag/getVinInfo`);
};

// 查询测试接头
export const getBlackSn = (limit, sn) => {
    return axiosInstance.get(`${baseURL1}/v1/diag/getBlackSn?limit=${limit}&sn=${sn}`);
};

// 查询黑名单统计
export const getBlackSnStats = (useBaseURL = 'X431 Server') => {
    const baseURL = chooseBaseURLEx(useBaseURL);
    return axiosInstance.get(`${baseURL}/v1/diag/getBlackSnStats`);
};

// 导出全部黑名单序列号 txt
export const downloadBlackSnTxt = async (useBaseURL = 'X431 Server') => {
    const baseURL = chooseBaseURLEx(useBaseURL);
    const response = await axiosInstance.get(`${baseURL}/v1/diag/downloadBlackSnTxt`, {
        responseType: 'blob'
    });
    Triggerdownload(response);
};

// 添加测试接头
export const syncFordBlacklistServers = () => {
    return axiosInstance.get(`${baseURL3}/v1/setlog/setredisallblacklist?pass=wonihaoma`, {
        timeout: 120 * 1000
    });
};

export const refreshBlackSnConfigs = (limit = 50) => {
    return axiosInstance.get(`${baseURL1}/v1/diag/refreshBlackSnConfigs`, {
        params: { limit },
        timeout: 30 * 1000
    });
};

export const addBlackSn = (data) => {
    return axiosInstance.post(`${baseURL1}/v1/diag/setBlackSn`, data);
};

// 删除测试接头
export const deleteBlackSn = (sn) => {
    return axiosInstance.delete(`${baseURL1}/v1/diag/deleteBlackSn/${sn}`);
};

// 查询测试接头
export const getTestSn = () => {
    return axiosInstance.get(`${baseURL1}/v1/diag/getTestSn`);
};
// 添加测试接头
export const addTestSn = (data) => {
    return axiosInstance.post(`${baseURL1}/v1/diag/setTestSn`, data);
};
// 删除测试接头
export const deleteTestSn = (sn) => {
    return axiosInstance.delete(`${baseURL1}/v1/diag/deleteTestSn/${sn}`);
};

// 添加测试模板接头
export const addTestTempSn = (data) => {
    return axiosInstance.post(`${baseURL1}/v1/diag/setTestTempSn`, data);
};
// 删除测试模板接头
export const deleteTestTempSn = (sn) => {
    return axiosInstance.delete(`${baseURL1}/v1/diag/deleteTestTempSn/${sn}`);
};

// Ford V5075 Redis 开关后台管理
export const getFordV5075RedisSwitches = () => {
    return axiosInstance.get(`${baseURL1}/v1/admin/ford/v5075/redis-switches`);
};

export const setFordV5075NewCurlMode = (mode) => {
    return axiosInstance.put(`${baseURL1}/v1/admin/ford/v5075/new-curl-mode`, { mode });
};

export const getFordV5075NewCurlSn = () => {
    return axiosInstance.get(`${baseURL1}/v1/admin/ford/v5075/new-curl-sn`);
};

export const addFordV5075NewCurlSn = (sn) => {
    return axiosInstance.post(`${baseURL1}/v1/admin/ford/v5075/new-curl-sn`, { sn });
};

export const deleteFordV5075NewCurlSn = (sn) => {
    return axiosInstance.delete(`${baseURL1}/v1/admin/ford/v5075/new-curl-sn/${encodeURIComponent(sn)}`);
};

export const setFordV5075DeliverFallbackV2 = (enabled) => {
    return axiosInstance.put(`${baseURL1}/v1/admin/ford/v5075/deliver-fallback-v2`, { enabled });
};

export const setFordV5075Auth800ReleaseMode = (mode) => {
    return axiosInstance.put(`${baseURL1}/v1/admin/ford/v5075/auth-800-release-mode`, { mode });
};

export const getFordRiskControlConfig = () => {
    return axiosInstance.get(`${baseURL1}/v1/admin/ford/risk-control/config`);
};

export const saveFordRiskControlConfig = (config) => {
    return axiosInstance.put(`${baseURL1}/v1/admin/ford/risk-control/config`, config);
};

export const setFordRiskControlEnabled = (enabled) => {
    return axiosInstance.put(`${baseURL1}/v1/admin/ford/risk-control/enabled`, { enabled });
};

export const getFordExtraVinLimit = (sn) => {
    return axiosInstance.get(`${baseURL1}/v1/admin/ford/redis/extra-vin-limit`, {
        params: { sn }
    });
};

export const saveFordExtraVinLimit = (sn, limit) => {
    return axiosInstance.put(`${baseURL1}/v1/admin/ford/redis/extra-vin-limit`, {
        sn,
        limit
    });
};

export const deleteFordExtraVinLimit = (sn) => {
    return axiosInstance.delete(
        `${baseURL1}/v1/admin/ford/redis/extra-vin-limit/${encodeURIComponent(sn)}`
    );
};

// Ford VIN 过滤规则后台管理
const vinFilterCopyQuery = (sync = true) => {
    return sync ? '' : '?copy=local';
};

export const getFordVinFilterRules = () => {
    return axiosInstance.get(`${baseURL1}/v1/admin/ford/vin-filter/rules`);
};

export const createFordVinFilterRule = (data, sync = true) => {
    return axiosInstance.post(`${baseURL1}/v1/admin/ford/vin-filter/rules${vinFilterCopyQuery(sync)}`, data);
};

export const updateFordVinFilterRule = (id, data, sync = true) => {
    return axiosInstance.put(`${baseURL1}/v1/admin/ford/vin-filter/rules/${encodeURIComponent(id)}${vinFilterCopyQuery(sync)}`, data);
};

export const deleteFordVinFilterRule = (id, sync = true) => {
    return axiosInstance.delete(`${baseURL1}/v1/admin/ford/vin-filter/rules/${encodeURIComponent(id)}${vinFilterCopyQuery(sync)}`);
};

export const testFordVinFilterRules = (data) => {
    return axiosInstance.post(`${baseURL1}/v1/admin/ford/vin-filter/test`, data);
};

// Ford Deliver data strategy
const deliverStrategyCopyQuery = (sync = true) => {
    return sync ? '' : '?copy=local';
};

export const getFordDeliverStrategyStatus = () => {
    return axiosInstance.get(`${baseURL1}/v1/admin/ford/deliver-strategy/status`);
};

export const getFordDeliverStrategyRules = (params = {}) => {
    return axiosInstance.get(`${baseURL1}/v1/admin/ford/deliver-strategy/rules`, { params });
};

export const uploadFordDeliverStrategyRules = (data, sync = true) => {
    return axiosInstance.post(`${baseURL1}/v1/admin/ford/deliver-strategy/upload${deliverStrategyCopyQuery(sync)}`, data);
};

export const addFordDeliverStrategyManualRules = (data, sync = true) => {
    return axiosInstance.post(`${baseURL1}/v1/admin/ford/deliver-strategy/manual-rules${deliverStrategyCopyQuery(sync)}`, data);
};

export const deleteFordDeliverStrategyRule = (id, sync = true) => {
    return axiosInstance.delete(`${baseURL1}/v1/admin/ford/deliver-strategy/rules/${encodeURIComponent(id)}${deliverStrategyCopyQuery(sync)}`);
};

export const publishFordDeliverStrategy = (sync = true) => {
    return axiosInstance.post(`${baseURL1}/v1/admin/ford/deliver-strategy/publish${deliverStrategyCopyQuery(sync)}`, {});
};

export const testFordDeliverStrategyVin = (data) => {
    return axiosInstance.post(`${baseURL1}/v1/admin/ford/deliver-strategy/test`, data);
};

export const queryFordDeliverStrategyRedis = (params = {}) => {
    return axiosInstance.get(`${baseURL1}/v1/admin/ford/deliver-strategy/redis/query`, { params });
};

export const getFordDeliverStrategyRedisStats = () => {
    return axiosInstance.get(`${baseURL1}/v1/admin/ford/deliver-strategy/redis/stats`);
};

export const getFordDeliverStrategyRedisKeys = (params = {}) => {
    return axiosInstance.get(`${baseURL1}/v1/admin/ford/deliver-strategy/redis/keys`, { params });
};

export const verifyFordDeliverStrategyRedis = (params = {}) => {
    return axiosInstance.get(`${baseURL1}/v1/admin/ford/deliver-strategy/redis/verify`, { params });
};

export const getFordDeliverVinIndexStatus = () => {
    return axiosInstance.get(`${baseURL1}/v1/admin/ford/deliver-vin-index/status`);
};

export const rebuildFordDeliverVinIndex = (params = {}) => {
    const requestParams = {
        batch: params.batch || 5000,
        reset: params.reset ? params.reset : '0',
    };
    if (params.cursor) {
        requestParams.cursor = params.cursor;
    }
    return axiosInstance.post(`${baseURL1}/v1/admin/ford/deliver-vin-index/rebuild`, {}, {
        params: requestParams,
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

// 用户登录请求  
export const adminResetUserPassword = (data) => {
    return axiosInstance.post(`${baseURL1}/v1/admin/users/reset-password`, data);
};

export const adminListUsers = () => {
    return axiosInstance.get(`${baseURL1}/v1/admin/users`);
};

export const adminCreateUser = (data) => {
    return axiosInstance.post(`${baseURL1}/v1/admin/users`, data);
};

export const adminUpdateUser = (username, data) => {
    return axiosInstance.put(`${baseURL1}/v1/admin/users/${encodeURIComponent(username)}`, data);
};

export const adminUpdateUserLoginIpWhitelist = (username, data) => {
    return axiosInstance.put(`${baseURL1}/v1/admin/users/${encodeURIComponent(username)}/login-ip-whitelist`, data);
};

export const adminGetUserIpAccessLogs = (params = {}) => {
    return axiosInstance.get(`${baseURL1}/v1/admin/users/ip-access-logs`, { params });
};

const triggerBlobDownload = (response, fallbackFilename = 'download') => {
    const blob = new Blob([response.data], {
        type: response.headers['content-type'] || 'application/octet-stream'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    const contentDisposition = response.headers['content-disposition'] || '';
    const matchedFilename =
        contentDisposition.match(/filename\*=UTF-8''([^;]+)/i) ||
        contentDisposition.match(/filename="?([^";]+)"?/i);
    const filename = matchedFilename
        ? decodeURIComponent(matchedFilename[1])
        : fallbackFilename;

    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

const sgmBaseURL = (serverName = 'CN Server') => chooseBaseURLEx(serverName);

export const getSgmFileTree = (path = '', serverName = 'CN Server') => {
    return axiosInstance.get(`${sgmBaseURL(serverName)}/v1/sgm/files/tree`, {
        params: path ? { path } : {}
    });
};

export const previewSgmFile = (path, serverName = 'CN Server') => {
    return axiosInstance.get(`${sgmBaseURL(serverName)}/v1/sgm/files/preview`, {
        params: { path },
        responseType: 'text',
        transformResponse: [(data) => data]
    });
};

export const downloadSgmFile = async (path, serverName = 'CN Server') => {
    const response = await axiosInstance.get(`${sgmBaseURL(serverName)}/v1/sgm/files/download`, {
        params: { path },
        responseType: 'blob'
    });
    triggerBlobDownload(response, path?.split(/[\\/]/).pop() || 'sgm-file');
};

export const uploadSgmFile = (dir, file, serverName = 'CN Server') => {
    const formData = new FormData();
    formData.append('dir', dir || '');
    formData.append('file', file);

    return axiosInstance.post(`${sgmBaseURL(serverName)}/v1/sgm/files/upload`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        timeout: 120 * 1000
    });
};

export const replaceSgmRuntimeFile = (path, file, serverName = 'CN Server') => {
    const formData = new FormData();
    formData.append('path', path);
    formData.append('file', file);

    return axiosInstance.post(`${sgmBaseURL(serverName)}/v1/sgm/files/replace`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        timeout: 120 * 1000
    });
};

export const deleteSgmFile = (path, serverName = 'CN Server') => {
    return axiosInstance.post(`${sgmBaseURL(serverName)}/v1/sgm/files/delete`, { path }, {
        timeout: 120 * 1000
    });
};

export const runSgmScript = (path, serverName = 'CN Server') => {
    return axiosInstance.post(`${sgmBaseURL(serverName)}/v1/sgm/files/run`, { path }, {
        timeout: 120 * 1000
    });
};

export const getFordSecurityCheckLogs = (serverName = 'CN Server', params = {}) => {
    const baseURL = chooseBaseURLEx(serverName);
    const queryParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') {
            return;
        }
        queryParams.set(key, value);
    });

    const queryString = queryParams.toString();
    return axiosInstance.get(`${baseURL}/v1/admin/ford/security-check-logs${queryString ? `?${queryString}` : ''}`);
};

export const runFordDiagnosticSimulator = (serverKey, data) => {
    const baseURL = chooseFordSimulatorBaseURL(serverKey);
    return axiosInstance.post(`${baseURL}/v1/admin/ford/simulator/run`, data, { timeout: 120 * 1000 });
};

export const userLogin = (data) => {
    return axiosInstance.post(`${baseURL1}/v1/user/token`, data);
};

// 保存用户日志格式  
export const userSaveLogFormat = (data) => {
    return axiosInstance.post(`${baseURL1}/v1/user/SaveLogFormat`, data);
};
export const userSaveName = (data) => {
    return axiosInstance.post(`${baseURL1}/v1/user/SaveName`, data);
};
export const userSavePassword = (data) => {
    return axiosInstance.post(`${baseURL1}/v1/user/SavePassword`, data);
};
//查询服务器后台日志数据
const buildLogQueryString = (baseParams, extraParams = {}) => {
    const queryParams = new URLSearchParams();

    Object.entries(baseParams || {}).forEach(([key, value]) => {
        queryParams.set(key, value ?? '');
    });

    Object.entries(extraParams || {}).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') {
            return;
        }
        queryParams.set(key, value);
    });

    return queryParams.toString();
};

export const getPageInfo = (limit, sn, useBaseURL = true, params = {}) => {
    const baseURL = chooseBaseURL(useBaseURL);
    const queryString = buildLogQueryString({ limit, sn }, params);
    return axiosInstance.get(`${baseURL}/v1/setlog/getpagelog?${queryString}`);
};

export const getPageInfoVin = (limit, vin, useBaseURL = true, params = {}) => {
    const baseURL = chooseBaseURL(useBaseURL);
    const queryString = buildLogQueryString({ limit, vin }, params);
    return axiosInstance.get(`${baseURL}/v1/setlog/getpagelogvin?${queryString}`);
};

export async function isAuthenticated() {
    const token = localStorage.getItem('authToken');

    if (!token) {
        return false; // 如果没有 token，直接返回 false  
    }

    try {
        const response = await getUserInfo(); // 等待 getUserInfo() 的结果  
        store.commit('setUserData', response.data.userInfo); // 更新 Vuex store  

        if (response.data.hasOwnProperty('LogFormat')) {
            store.commit('setLogFormat', response.data.LogFormat);
        }
        return true; // 验证成功，返回 true  
    } catch (error) {
        console.error('Error validating token:', error); // 记录错误  
        return false; // 验证失败，返回 false  
    }
}


//xk请求接口
export const Post_xk_setSomeOne = (urlFunc,data) => {
    const baseURL = "http://diagapi.xk.wwftool.top:6482/api";
    return axiosInstance.post(`${baseURL}/v1/${urlFunc}`, data);
};


//通用请求接口
export const getSomeOne = (useBaseURL, urlFunc) => {
    const baseURL = chooseBaseURLEx(useBaseURL);
    
    const url = buildRequestUrl(baseURL,urlFunc);
    
    return axiosInstance.get(url);
};

export const setSomeOne = (useBaseURL, datevalue,urlFunc) => {
    
    const baseURL = chooseBaseURLEx(useBaseURL);
    const url = buildRequestUrl(baseURL, urlFunc);
    return axiosInstance.get(`${url}?data=${datevalue}`);
};

export const Post_setSomeOne = (useBaseURL, data, urlFunc) => {
    const baseURL = chooseBaseURLEx(useBaseURL);
    const url = buildRequestUrl(baseURL, urlFunc);
    return axiosInstance.post(url, data);
};

export const Post_setSomeOneDNS = (data,urlFunc) => {
    return axiosInstance.post(`${baseURL1}/v1/${urlFunc}`, data);
};

export const deleteSomeOne = (useBaseURL, urlFunc) => {
    const baseURL = chooseBaseURLEx(useBaseURL);
    const url = buildRequestUrl(baseURL, urlFunc);
    return axiosInstance.delete(url);
};

export const DownloadSomeOne = async (useBaseURL,urlFunc,filename, params = {}) => {
    // 构造完整的 URL - 页面只有在下载完成后，才会显示下载成功，大文件不适合用这种接口
    const baseURL = chooseBaseURL(useBaseURL);
    let url = `${baseURL}/v1/diag/${urlFunc}`;
    const queryParams = new URLSearchParams();
    if (filename) {
        queryParams.set('filename', filename);
    }
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.set(key, value);
        }
    });
    const queryString = queryParams.toString();
    if (queryString) {
        url += `?${queryString}`;
    }

    const response = await axiosInstance.get(url);
    Triggerdownload(response);// 创建一个 URL 并触发下载  
};

export const StreamDownloadSomeOne = async (useBaseURL,urlFunc,filename) => {
    // 构造完整的 URL - 页面只有在下载完成后，才会显示下载成功，大文件不适合用这种接口
    const baseURL = chooseBaseURL(useBaseURL);
    const token = localStorage.getItem("authToken");  
    const url = `${baseURL}/v1/diag/${urlFunc}?filename=${filename}&token=${token}`;

    documentDown(url, filename);
};

export const DownloadSomeOne_bigFile = async (useBaseURL,urlFunc,filename) => {
    // 构造完整的 URL - 大文件下载-需要显示下载进度，把token放置到请求参数中判断
    const baseURL = chooseBaseURL(useBaseURL);
    let url = `${baseURL}/v1/diag/${urlFunc}`;
    const token = localStorage.getItem("authToken");  
    if (filename) {
        url += `?filename=${encodeURIComponent(filename)}&token=${token}`;
    }
    else{
        url += `?filename=null&token=${token}`;
    }

    const response = await axiosInstance.get(url);
    Triggerdownload(response);// 创建一个 URL 并触发下载  
};

export const getDocMarkdown = (useBaseURL, path) => {
  const baseURL = chooseBaseURLEx(useBaseURL)
  const url = buildRequestUrl(baseURL, 'apidoc/Markdown')

  return axiosInstance.get(url, {
    params: {
      path
    },
    responseType: 'text'
  })
};

export const getDocPdfUrl = (useBaseURL, path) => {
  const baseURL = chooseBaseURLEx(useBaseURL)
  const token = localStorage.getItem('authToken')

  return buildRequestUrl(
    baseURL,
    `apidoc/previewDPF?path=${encodeURIComponent(path)}&token=${encodeURIComponent(token)}`
  )
};

export const downloadDocMarkdown = async (useBaseURL, path, filename) => {
  const baseURL = chooseBaseURLEx(useBaseURL)
  const url = buildRequestUrl(baseURL, 'apidoc/downloadMarkdown')

  const response = await axiosInstance.get(url, {
    params: { path },
    responseType: 'blob'
  })
  const blob = new Blob([response.data], {
    type: response.headers['content-type'] || 'text/markdown;charset=utf-8'
  })
  const downloadUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  const contentDisposition = response.headers['content-disposition'] || ''
  const matchedFilename =
    contentDisposition.match(/filename\*=UTF-8''([^;]+)/i) ||
    contentDisposition.match(/filename="?([^";]+)"?/i)
  const responseFilename = matchedFilename
    ? decodeURIComponent(matchedFilename[1])
    : ''

  link.href = downloadUrl
  link.setAttribute('download', responseFilename || filename || path?.split(/[\\/]/).pop() || 'document.md')
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(downloadUrl)
};
//IMMO
export const getImmoMode = (data) => {
    return axiosInstance.post(`${baseURL1}/v1/immo/getimmomode`, data);
};

export const addImmoMode = (data) => {
    return axiosInstance.post(`${baseURL1}/v1/immo/addimmomode`, data);
};

export const updateImmoMode = (data) => {
    return axiosInstance.post(`${baseURL1}/v1/immo/updateimmomode`, data);
};

export const deleteImmoMode = (id) => {
    return axiosInstance.delete(`${baseURL1}/v1/immo/deleteimmomode/${id}`);
};


// 上传文档
export const uploadDoc = (useBaseURL, formData) => {
    const baseURL = chooseBaseURLEx(useBaseURL);  
    const url = buildRequestUrl(baseURL,'apidoc/upload');

  return axiosInstance.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
};

// 删除文档
export const deleteDoc = (useBaseURL, key) => {
  const baseURL = chooseBaseURLEx(useBaseURL)
  const url = buildRequestUrl(baseURL, 'apidoc/delete')

  return axiosInstance.post(url, { key })
};

// 重命名文档
export const renameDoc = (useBaseURL, key, newName) => {
  const baseURL = chooseBaseURLEx(useBaseURL)
  const url = buildRequestUrl(baseURL, 'apidoc/rename')

  return axiosInstance.post(url, { key, newName })
};

// 移动文档
export const moveDoc = (useBaseURL, key, targetKey) => {
  const baseURL = chooseBaseURLEx(useBaseURL)
  const url = buildRequestUrl(baseURL, 'apidoc/move')

  return axiosInstance.post(url, { key, targetKey })
};
// 创建目录
export const createDirectory = (useBaseURL, data) => {
  const baseURL = chooseBaseURLEx(useBaseURL)
  const url = buildRequestUrl(baseURL, 'apidoc/create-dir')

  return axiosInstance.post(url, data)
};
